import { prop, ComponentEventBus, inject } from "fw";

let uniqueId = 0;

@inject
export class FileField {
    constructor(private ceb: ComponentEventBus) {}

    @prop(null) label: string;
    @prop(null) validation: string;
    @prop(true) showValidation?: boolean;
    @prop(false) disabled: boolean;
    @prop("") cssClass: string;
    @prop(null) dataId: string;

    private uniqueId = uniqueId++;

    get id() {
        return `${this.label ? this.label.replace(/\s/g, "") : ""}-tf-${this.uniqueId}`;
    }

    public onChange(e: Event) {
        const val = (<HTMLInputElement>e.target).files[0];
        this.ceb.updateModel(val);
        this.ceb.dispatch("update:value", val);
    }
}
